import useSWR from 'swr'
import { fetcher } from '@/hooks'

/** 去掉空值，缺省参数不进请求 */
const compact = (params) => Object.fromEntries(Object.entries(params).filter(([, value]) => value != null && value !== ''))

/** query 为 null 时不发请求。error 合并网络错误与业务错误（data 为空时的 message） */
function useCeo(endpoint, query) {
  const result = useSWR(query ? [endpoint, query] : null, fetcher, { revalidateOnFocus: false })
  return {
    data: result.data?.data,
    isLoading: result.isLoading,
    error: result.error?.message ?? (result.data && !result.data.data ? result.data.message : null),
  }
}

/** MON-93 GET /ceo/payback?node=&countries=&as_of=（node 缺省 total，countries 缺省全部国家，as_of 缺省最新） */
export const usePayback = (query) =>
  useCeo('/ceo/payback', query && compact({ node: query.node, countries: query.countries, as_of: query.asOf }))

/** MON-81 / MON-93 GET /ceo/payback/compare?node=&countries=&as_of=&date=；query 为 null 时不发请求 */
export const usePaybackCompare = (query) =>
  useCeo(
    '/ceo/payback/compare',
    query && compact({ node: query.node, countries: query.countries, as_of: query.asOf, date: query.date }),
  )
